import RecordingIndicator from './RecordingIndicator';

export default RecordingIndicator;
